module.exports = __webpack_public_path__ + "img/ABRAZADERA DE BROCHE.e16500a1.jpg";